module.exports = __webpack_public_path__ + "img/SimplifyLogo.fbdbe02a.png";